const wrapComponentRender = require('utils/framework/wrapComponentRender').wrapComponentRender;

const wrapUFE = (comp, hasCtrlr) => {
    comp.prototype.hasCtrlr = hasCtrlr;
    comp.displayName = comp.prototype.displayName = comp.prototype.class = comp.class || comp.name;
    Sephora.Util.InflatorComps.Comps[comp.prototype.class] = {
        getReactClass: function () { // eslint-disable-line max-len, func-name-matching
            return comp;
        }
    };
    Sephora.Util.InflatorComps.Comps[comp.prototype.class].class = comp;
    comp.prototype.render = wrapComponentRender(comp);

    return comp;
};

module.exports = wrapUFE;
